import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import MobileTabs from 'src/components/MobileTabs';
import DesktopTabs from 'src/components/DesktopTabs';
import { setTab } from 'src/redux/actions/tabs';
import { getAdvices, setAdvices } from 'src/redux/actions/advices';
import categoryType from 'src/types/category';


const Tabs = ({ categories, activateTab }) => (
  <Fragment>
    <MobileTabs activateTab={ activateTab } categories={ categories } />
    <DesktopTabs activateTab={ activateTab } categories={ categories } />
  </Fragment>
);

Tabs.propTypes = {
  activateTab: PropTypes.func.isRequired,
  categories: PropTypes.arrayOf(PropTypes.shape(categoryType)).isRequired
};


const mapStateToProperties = (state) => {
  const { categories } = state.categoriesReducer;
  const { activeTab } = state.tabsReducer;

  return {
    categories: categories
      .map(category => ({
        ...category,
        active: category.id === activeTab
      }))
  };
};

const mapDispatchToProperties = dispatch => ({
  activateTab: (categoryId) => {
    dispatch(setTab(categoryId));
    dispatch(getAdvices({
      categoryId
    }))
      .catch(() => {
        dispatch(setAdvices([]));
      });
  }
});


export default connect(mapStateToProperties, mapDispatchToProperties)(Tabs);
